import React from "react";
import PropTypes from "prop-types";
import { cn } from '../../utils/lib/utils';
import { Card } from "./card";

/**
 * @typedef {Object} ChartCardProps
 * @property {*} title
 * @property {*} children.ReactNode
 * @property {*} className?
 */

const ChartCard = ({ title, children, className, ...props }) => {
  return (
    <Card
      variant="chart"
      className={cn("overflow-hidden", className)}
      {...props}
    >
      {title && (
        <div className="border-b border-border/20 p-6">
          <h3 className="text-lg font-semibold">{title}</h3>
        </div>
      )}
      <div className="p-6">{children}</div>
    </Card>
  );
};

ChartCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

export { ChartCard };
